
import { Worksheet } from './all-worksheets';

/* -------------------------------------------------------------------------- */
/*  FREE WORKSHEETS (K‑5)                                                     */
/* -------------------------------------------------------------------------- */
export const worksheetsK5: Worksheet[] = [
  // Kindergarten
  {
    id: 'k-counting-1-10',
    title: 'Counting Objects 1-10',
    description:
      'Practice counting everyday objects from 1 to 10 with colorful illustrations and number tracing exercises.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Beginner',
    pages: 3,
    isFree: true,
    downloadUrl: '/downloads/k-counting-1-10.pdf',
    thumbnailUrl:
      'https://public.readdy.ai/ai/img_res/301d4800ba4ca61b5d0f9401bb4dff2c.jpg',
  },
  {
    id: 'k-shapes-basic',
    title: 'Basic Shapes Recognition',
    description:
      'Identify and trace circles, squares, triangles, and rectangles with fun real-world examples.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Shapes',
    difficulty: 'Beginner',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/k-shapes-basic.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20shapes%20worksheet%20with%20colorful%20geometric%20shapes%20circles%20squares%20triangles%20rectangles%2C%20playful%20educational%20design%2C%20objects%20matching%20shapes%20like%20pizza%20slice%20and%20ball%2C%20bright%20colors%2C%20clean%20simple%20background&width=400&height=500&seq=k002&orientation=portrait',
  },
  {
    id: 'k-patterns-colors',
    title: 'Color and Shape Patterns',
    description:
      'Complete simple AB and ABC patterns using colors and shapes to build early logic skills.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Patterns',
    difficulty: 'Beginner',
    pages: 3,
    isFree: true,
    downloadUrl: '/downloads/k-patterns-colors.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20pattern%20worksheet%20with%20repeating%20sequences%20of%20colorful%20shapes%20and%20objects%2C%20AB%20and%20ABC%20patterns%2C%20cheerful%20educational%20illustration%2C%20simple%20clean%20background%20with%20bright%20primary%20colors&width=400&height=500&seq=k003&orientation=portrait',
  },
  {
    id: 'k-addition-intro',
    title: 'Introduction to Addition',
    description:
      'Learn basic addition with numbers 1-5 using visual aids and counting pictures.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Beginner',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/k-addition-intro.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20addition%20worksheet%20with%20cute%20illustrations%20showing%20simple%20math%20problems%20using%20pictures%20of%20toys%20and%20fruits%2C%20numbers%20one%20to%20five%2C%20plus%20signs%2C%20colorful%20and%20engaging%2C%20clean%20educational%20background&width=400&height=500&seq=k004&orientation=portrait',
  },
  {
    id: 'k-measurement-compare',
    title: 'Comparing Sizes',
    description:
      'Compare objects by size using bigger, smaller, longer, and shorter concepts.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Measurement',
    difficulty: 'Beginner',
    pages: 3,
    isFree: true,
    downloadUrl: '/downloads/k-measurement-compare.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20measurement%20worksheet%20comparing%20sizes%20of%20animals%20and%20objects%2C%20bigger%20and%20smaller%20concepts%2C%20tall%20and%20short%20comparisons%2C%20friendly%20educational%20illustrations%2C%20bright%20colors%2C%20simple%20clean%20background&width=400&height=500&seq=k005&orientation=portrait',
  },

  // Grade 1
  {
    id: 'g1-addition-20',
    title: 'Addition Within 20',
    description:
      'Master single-digit addition and sums up to 20 with word problems and visual models.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Beginner',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g1-addition-20.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20math%20worksheet%20with%20addition%20problems%20up%20to%20twenty%2C%20number%20lines%20and%20ten%20frames%2C%20colorful%20educational%20design%20with%20simple%20illustrations%2C%20clean%20white%20background&width=400&height=500&seq=g101&orientation=portrait',
  },
  {
    id: 'g1-subtraction-20',
    title: 'Subtraction Within 20',
    description:
      'Practice subtraction facts and strategies with numbers up to 20 using pictures and equations.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Beginner',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g1-subtraction-20.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20subtraction%20worksheet%20with%20minus%20problems%20up%20to%20twenty%2C%20crossing%20out%20objects%2C%20number%20bonds%2C%20friendly%20educational%20illustrations%2C%20bright%20colors%2C%20clean%20simple%20background&width=400&height=500&seq=g102&orientation=portrait',
  },
  {
    id: 'g1-place-value',
    title: 'Tens and Ones Place Value',
    description:
      'Understand place value with tens and ones using base-10 blocks and number charts.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Place Value',
    difficulty: 'Beginner',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g1-place-value.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20place%20value%20worksheet%20showing%20base%20ten%20blocks%2C%20tens%20and%20ones%20columns%2C%20number%20decomposition%20exercises%2C%20educational%20math%20illustration%2C%20clean%20organized%20layout%2C%20simple%20background&width=400&height=500&seq=g103&orientation=portrait',
  },
  {
    id: 'g1-time-hour',
    title: 'Telling Time to the Hour',
    description:
      'Learn to read analog clocks and tell time to the nearest hour with practice problems.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Time',
    difficulty: 'Beginner',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g1-time-hour.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20telling%20time%20worksheet%20with%20multiple%20analog%20clock%20faces%20showing%20different%20hours%2C%20colorful%20clock%20hands%2C%20time%20matching%20exercises%2C%20educational%20design%2C%20clean%20white%20background&width=400&height=500&seq=g104&orientation=portrait',
  },
  {
    id: 'g1-shapes-2d',
    title: '2D Shapes and Attributes',
    description:
      'Identify and describe 2D shapes including sides, corners, and real-world examples.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Beginner',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g1-shapes-2d.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20geometry%20worksheet%20with%20two%20dimensional%20shapes%2C%20counting%20sides%20and%20corners%2C%20shape%20attributes%2C%20colorful%20geometric%20figures%2C%20educational%20illustration%20style%2C%20simple%20clean%20background&width=400&height=500&seq=g105&orientation=portrait',
  },

  // Grade 2
  {
    id: 'g2-addition-100',
    title: 'Addition Within 100',
    description:
      'Add two-digit numbers with and without regrouping using place value strategies.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Beginner',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g2-addition-100.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20addition%20worksheet%20with%20two%20digit%20numbers%2C%20regrouping%20exercises%2C%20place%20value%20charts%2C%20organized%20math%20problems%20layout%20%2C%20educational%20design%2C%20clean%20white%20background&width=400&height=500&seq=g201&orientation=portrait',
  },
  {
    id: 'g2-subtraction-100',
    title: 'Subtraction Within 100',
    description:
      'Subtract two-digit numbers with borrowing and solve word problems.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Beginner',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g2-subtraction-100.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20subtraction%20worksheet%20with%20two%20digit%20numbers%2C%20borrowing%20problems%2C%20word%20problems%20with%20illustrations%20%2C%20educational%20math%20design%20%2C%20organized%20layout%20%2C%20simple%20clean%20background&width=400&height=500&seq=g202&orientation=portrait',
  },
  {
    id: 'g2-money-coins',
    title: 'Counting Money and Coins',
    description:
      'Count and compare coins and dollars, make change, and solve money word problems.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Money',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g2-money-coins.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20money%20worksheet%20with%20coins%20pennies%20nickels%20dimes%20quarters%2C%20counting%20money%20exercises%2C%20dollar%20bills%2C%20price%20tags%2C%20educational%20financial%20literacy%20design%2C%20clean%20organized%20background&width=400&height=500&seq=g203&orientation=portrait',
  },
  {
    id: 'g2-measurement-length',
    title: 'Measuring Length',
    description:
      'Measure objects using rulers, compare lengths, and solve measurement problems.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Measurement',
    difficulty: 'Beginner',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g2-measurement-length.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20measurement%20worksheet%20with%20rulers%20showing%20inches%20and%20centimeters%2C%20objects%20to%20measure%20like%20pencils%20and%20crayons%2C%20length%20comparison%20exercises%20%2C%20educational%20design%2C%20simple%20clean%20background&width=400&height=500&seq=g204&orientation=portrait',
  },
  {
    id: 'g2-arrays-multiplication',
    title: 'Introduction to Arrays',
    description:
      'Understand multiplication concepts using arrays and equal groups with visual models.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Multiplication',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g2-arrays-multiplication.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20arrays%20worksheet%20showing%20rows%20and%20columns%20of%20objects%2C%20equal%20groups%2C%20introduction%20to%20multiplication%20%2C%20colorful%20dots%20and%20shapes%20arranged%20in%20grids%2C%20educational%20math%20illustration%2C%20clean%20background&width=400&height=500&seq=g205&orientation=portrait',
  },

  // Grade 3
  {
    id: 'g3-multiplication-facts',
    title: 'Multiplication Facts 0-12',
    description:
      'Master multiplication tables from 0 to 12 with timed drills and word problems.',
    grade: 'Grade 3',
    subject: 'Math',
    topic: 'Multiplication',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g3-multiplication-facts.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=third%20grade%20multiplication%20worksheet%20with%20times%20tables%2C%20multiplication%20facts%20practice%2C%20organized%20grid%20layout%2C%20educational%20math%20design%2C%20clean%20white%20background%20with%20colorful%20numbers&width=400&height=500&seq=g301&orientation=portrait',
  },
  {
    id: 'g3-division-intro',
    title: 'Introduction to Division',
    description:
      'Learn division as equal sharing and grouping with visual models and basic facts.',
    grade: 'Grade 3',
    subject: 'Math',
    topic: 'Division',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g3-division-intro.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=third%20grade%20division%20worksheet%20with%20equal%20groups%2C%20sharing%20objects%2C%20division%20symbols%2C%20visual%20models%20with%20circles%20and%20arrays%2C%20educational%20math%20illustration%20%2C%20simple%20clean%20background&width=400&height=500&seq=g302&orientation=portrait',
  },
  {
    id: 'g3-fractions-basic',
    title: 'Understanding Fractions',
    description:
      'Identify, compare, and represent fractions using models and number lines.',
    grade: 'Grade 3',
    subject: 'Math',
    topic: 'Fractions',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g3-fractions-basic.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=third%20grade%20fractions%20worksheet%20with%20fraction%20circles%20and%20bars%2C%20shaded%20parts%2C%20number%20lines%20showing%20fractions%2C%20comparing%20fractions%2C%20colorful%20educational%20design%2C%20clean%20organized%20background&width=400&height=500&seq=g303&orientation=portrait',
  },
  {
    id: 'g3-area-perimeter',
    title: 'Area and Perimeter',
    description:
      'Calculate area and perimeter of rectangles and solve real-world measurement problems.',
    grade: 'Grade 3',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g3-area-perimeter.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=third%20grade%20area%20and%20perimeter%20worksheet%20with%20rectangles%20and%20squares%2C%20grid%20paper%2C%20measurement%20problems%2C%20labeled%20dimensions%2C%20educational%20geometry%20design%2C%20clean%20simple%20background&width=400&height=500&seq=g304&orientation=portrait',
  },
  {
    id: 'g3-word-problems',
    title: 'Multi-Step Word Problems',
    description:
      'Solve word problems involving multiple operations and real-world scenarios.',
    grade: 'Grade 3',
    subject: 'Math',
    topic: 'Problem Solving',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: true,
    downloadUrl: '/downloads/g3-word-problems.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=third%20grade%20word%20problems%20worksheet%20with%20story%20problems%2C%20illustrations%20of%20real%20world%20scenarios%2C%20space%20for%20showing%20work%2C%20organized%20problem%20layout%20%2C%20educational%20design%20%2C%20clean%20white%20background&width=400&height=500&seq=g305&orientation=portrait',
  },

  // Grade 4
  {
    id: 'g4-multi-digit-multiplication',
    title: 'Multi-Digit Multiplication',
    description:
      'Multiply multi-digit numbers using the standard algorithm and area models.',
    grade: 'Grade 4',
    subject: 'Math',
    topic: 'Multiplication',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g4-multi-digit-multiplication.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fourth%20grade%20multiplication%20worksheet%20with%20multi%20digit%20numbers%2C%20standard%20algorithm%20layout%2C%20area%20models%2C%20organized%20problem%20sets%2C%20educational%20math%20design%2C%20clean%20white%20background&width=400&height=500&seq=g401&orientation=portrait',
  },
  {
    id: 'g4-long-division',
    title: 'Long Division Practice',
    description:
      'Master long division with remainders and check answers using multiplication.',
    grade: 'Grade 4',
    subject: 'Math',
    topic: 'Division',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g4-long-division.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fourth%20grade%20long%20division%20worksheet%20with%20division%20brackets%2C%20step%20by%20step%20problems%20%2C%20remainders%2C%20organized%20layout%20for%20showing%20work%2C%20educational%20math%20design%20%2C%20simple%20clean%20background&width=400&height=500&seq=g402&orientation=portrait',
  },
  {
    id: 'g4-fractions-operations',
    title: 'Adding and Subtracting Fractions',
    description:
      'Add and subtract fractions with like denominators and mixed numbers.',
    grade: 'Grade 4',
    subject: 'Math',
    topic: 'Fractions',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g4-fractions-operations.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fourth%20grade%20fractions%20worksheet%20with%20addition%20and%20subtraction%20of%20fractions%2C%20visual%20models%2C%20mixed%20numbers%2C%20common%20denominators%2C%20colorful%20educational%20design%20%2C%20clean%20organized%20background&width=400&height=500&seq=g403&orientation=portrait',
  },
  {
    id: 'g4-decimals-intro',
    title: 'Introduction to Decimals',
    description:
      'Understand decimal place value, compare decimals, and relate fractions to decimals.',
    grade: 'Grade 4',
    subject: 'Math',
    topic: 'Decimals',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g4-decimals-intro.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fourth%20grade%20decimals%20worksheet%20with%20place%20value%20charts%2C%20decimal%20numbers%2C%20comparing%20decimals%2C%20fraction%20to%20decimal%20conversion%2C%20educational%20math%20design%2C%20clean%20white%20background&width=400&height=500&seq=g404&orientation=portrait',
  },
  {
    id: 'g4-angles-lines',
    title: 'Angles and Lines',
    description:
      'Identify and measure angles, classify triangles, and understand parallel and perpendicular lines.',
    grade: 'Grade 4',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g4-angles-lines.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fourth%20grade%20geometry%20worksheet%20with%20angles%2C%20protractors%2C%20acute%20obtuse%20right%20angles%2C%20parallel%20and%20perpendicular%20lines%2C%20triangles%2C%20educational%20geometric%20design%2C%20clean%20simple%20background&width=400&height=500&seq=g405&orientation=portrait',
  },

  // Grade 5
  {
    id: 'g5-decimal-operations',
    title: 'Decimal Operations',
    description:
      'Add, subtract, multiply, and divide decimals with real-world applications.',
    grade: 'Grade 5',
    subject: 'Math',
    topic: 'Decimals',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g5-decimal-operations.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fifth%20grade%20decimal%20operations%20worksheet%20with%20addition%20subtraction%20multiplication%20division%20of%20decimals%2C%20organized%20problem%20layout%2C%20place%20value%20alignment%2C%20educational%20math%20design%2C%20clean%20background&width=400&height=500&seq=g501&orientation=portrait',
  },
  {
    id: 'g5-fractions-multiply-divide',
    title: 'Multiplying and Dividing Fractions',
    description:
      'Multiply and divide fractions and mixed numbers using visual models and algorithms.',
    grade: 'Grade 5',
    subject: 'Math',
    topic: 'Fractions',
    difficulty: 'Intermediate',
    pages: 6,
    isFree: true,
    downloadUrl: '/downloads/g5-fractions-multiply-divide.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fifth%20grade%20fractions%20worksheet%20with%20multiplication%20and%20division%20of%20fractions%2C%20area%20models%2C%20mixed%20numbers%2C%20reciprocals%2C%20colorful%20educational%20design%2C%20clean%20organized%20background&width=400&height=500&seq=g502&orientation=portrait',
  },
  {
    id: 'g5-volume-rectangular',
    title: 'Volume of Rectangular Prisms',
    description:
      'Calculate volume using formulas and unit cubes with real-world problems.',
    grade: 'Grade 5',
    subject: 'Math',
    topic: 'Geometry',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g5-volume-rectangular.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fifth%20grade%20volume%20worksheet%20with%20three%20dimensional%20rectangular%20prisms%2C%20unit%20cubes%2C%20volume%20formulas%2C%20labeled%20dimensions%2C%20educational%20geometry%20design%2C%20clean%20simple%20background&width=400&height=500&seq=g503&orientation=portrait',
  },
  {
    id: 'g5-coordinate-plane',
    title: 'Coordinate Plane Graphing',
    description:
      'Plot points on coordinate planes and solve problems using ordered pairs.',
    grade: 'Grade 5',
    subject: 'Math',
    topic: 'Graphing',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g5-coordinate-plane.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fifth%20grade%20coordinate%20plane%20worksheet%20with%20x%20and%20y%20axes%2C%20grid%20paper%2C%20plotting%20points%2C%20ordered%20pairs%2C%20graphing%20exercises%2C%20educational%20math%20design%20%2C%20clean%20white%20background&width=400&height=500&seq=g504&orientation=portrait',
  },
  {
    id: 'g5-order-operations',
    title: 'Order of Operations',
    description:
      'Apply PEMDAS to evaluate expressions with multiple operations and grouping symbols.',
    grade: 'Grade 5',
    subject: 'Math',
    topic: 'Algebra',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: true,
    downloadUrl: '/downloads/g5-order-operations.pdf',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=fifth%20grade%20order%20of%20operations%20worksheet%20with%20PEMDAS%20problems%2C%20parentheses%20brackets%2C%20multi%20step%20expressions%20%2C%20organized%20problem%20layout%20%2C%20educational%20math%20design%20%2C%20clean%20background&width=400&height=500&seq=g505&orientation=portrait',
  },
];

/* -------------------------------------------------------------------------- */
/*  PAID WORKSHEETS (K‑5)                                                    */
/* -------------------------------------------------------------------------- */
export const worksheetsK5Paid: Worksheet[] = [
  // ---------- Kindergarten ----------
  {
    id: 'k-count-100-practice-1',
    title: 'Count to 100 by Ones - Practice Set 1',
    description:
      'Master counting from 1 to 100 with fill-in-the-blank sequences and number ordering exercises.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Beginner',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=colorful%20kindergarten%20counting%20worksheet%20with%20numbers%20one%20to%20one%20hundred%20displayed%20in%20bright%20cheerful%20rows%20with%20cute%20animal%20illustrations%20and%20simple%20clean%20white%20background%20designed%20for%20young%20children%20learning%20to%20count&width=400&height=520&seq=k-count-100-1&orientation=portrait',
  },
  {
    id: 'k-count-100-practice-2',
    title: 'Count to 100 by Tens - Practice Set 2',
    description:
      'Practice skip counting by tens from 10 to 100 with visual number line activities.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20skip%20counting%20by%20tens%20worksheet%20featuring%20colorful%20number%20line%20with%20groups%20of%20ten%20objects%20like%20stars%20and%20hearts%20on%20clean%20white%20background%20for%20early%20math%20learners&width=400&height=520&seq=k-count-100-2&orientation=portrait',
  },
  {
    id: 'k-count-100-practice-3',
    title: 'Missing Numbers 1-100 Challenge',
    description:
      'Find missing numbers in sequences and complete number charts from 1 to 100.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20missing%20numbers%20worksheet%20with%20hundred%20chart%20and%20blank%20spaces%20for%20children%20to%20fill%20in%20numbers%20with%20colorful%20borders%20and%20simple%20white%20background&width=400&height=520&seq=k-count-100-3&orientation=portrait',
  },
  {
    id: 'k-count-100-practice-4',
    title: 'Before, After, Between Numbers',
    description:
      'Identify numbers that come before, after, and between given numbers up to 100.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Intermediate',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20number%20sequence%20worksheet%20showing%20before%20after%20between%20concepts%20with%20colorful%20number%20trains%20and%20simple%20illustrations%20on%20white%20background&width=400&height=520&seq=k-count-100-4&orientation=portrait',
  },

  // ---------- Kindergarten – Count Objects ----------
  {
    id: 'k-count-objects-1',
    title: 'Count and Tell How Many - Set 1',
    description:
      'Count groups of objects from 1 to 10 and identify the total number.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Beginner',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20counting%20objects%20worksheet%20with%20groups%20of%20colorful%20toys%20fruits%20and%20animals%20for%20children%20to%20count%20with%20simple%20white%20background&width=400&height=520&seq=k-count-obj-1&orientation=portrait',
  },
  {
    id: 'k-count-objects-2',
    title: 'One-to-One Correspondence Practice',
    description:
      'Match each object with one number to develop counting accuracy.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20one%20to%20one%20correspondence%20worksheet%20with%20objects%20and%20numbers%20to%20match%20featuring%20bright%20colors%20and%20simple%20clean%20background&width=400&height=520&seq=k-count-obj-2&orientation=portrait',
  },
  {
    id: 'k-count-objects-3',
    title: 'Cardinal Numbers Practice',
    description:
      'Understand that the last number counted tells how many objects there are.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20cardinal%20numbers%20worksheet%20with%20groups%20of%20objects%20and%20number%20boxes%20for%20children%20to%20write%20totals%20on%20white%20background&width=400&height=520&seq=k-count-obj-3&orientation=portrait',
  },

  // ---------- Kindergarten – Compare Numbers ----------
  {
    id: 'k-compare-numbers-1',
    title: 'Greater Than, Less Than Practice',
    description:
      'Compare numbers 0-10 using greater than and less than symbols.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20comparing%20numbers%20worksheet%20with%20alligator%20symbols%20eating%20larger%20numbers%20and%20colorful%20number%20comparisons%20on%20white%20background&width=400&height=520&seq=k-compare-1&orientation=portrait',
  },
  {
    id: 'k-compare-numbers-2',
    title: 'Equal To Practice',
    description:
      'Identify when two groups have the same number of objects.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20equal%20groups%20worksheet%20with%20matching%20sets%20of%20objects%20and%20equal%20signs%20for%20young%20learners%20on%20simple%20white%20background&width=400&height=520&seq=k-compare-2&orientation=portrait',
  },
  {
    id: 'k-compare-numbers-3',
    title: 'Number Comparison Challenge',
    description:
      'Advanced comparison activities with numbers 0-10 using all three symbols.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Counting',
    difficulty: 'Advanced',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20number%20comparison%20challenge%20worksheet%20with%20mixed%20greater%20than%20less%20than%20equal%20to%20problems%20and%20colorful%20illustrations%20on%20white%20background&width=400&height=520&seq=k-compare-3&orientation=portrait',
  },

  // ---------- Kindergarten – Addition within 10 ----------
  {
    id: 'k-addition-10-1',
    title: 'Introduction to Addition - Picture Problems',
    description:
      'Learn addition concepts by putting together groups of objects.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Beginner',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20addition%20worksheet%20with%20colorful%20pictures%20of%20objects%20being%20combined%20together%20with%20plus%20signs%20for%20early%20learners%20on%20white%20background&width=400&height=520&seq=k-add-1&orientation=portrait',
  },
  {
    id: 'k-addition-10-2',
    title: 'Addition Facts 0-5',
    description: 'Practice basic addition facts with sums up to 5.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20simple%20addition%20facts%20worksheet%20with%20numbers%20zero%20to%20five%20and%20cute%20illustrations%20for%20beginning%20math%20students%20on%20white%20background&width=400&height=520&seq=k-add-2&orientation=portrait',
  },
  {
    id: 'k-addition-10-3',
    title: 'Addition Facts 0-10',
    description:
      'Master all addition combinations with sums up to 10.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20addition%20practice%20worksheet%20with%20numbers%20up%20to%20ten%20featuring%20colorful%20math%20problems%20and%20friendly%20designs%20on%20clean%20white%20background&width=400&height=520&seq=k-add-3&orientation=portrait',
  },
  {
    id: 'k-addition-10-4',
    title: 'Addition Word Problems',
    description:
      'Solve simple addition story problems with pictures and numbers.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Advanced',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20addition%20word%20problems%20worksheet%20with%20illustrated%20stories%20and%20simple%20math%20scenarios%20for%20young%20children%20on%20white%20background&width=400&height=520&seq=k-add-4&orientation=portrait',
  },

  // ---------- Kindergarten – Subtraction within 10 ----------
  {
    id: 'k-subtraction-10-1',
    title: 'Introduction to Subtraction - Taking Away',
    description:
      'Learn subtraction by crossing out objects and counting what remains.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Beginner',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20subtraction%20worksheet%20with%20objects%20being%20crossed%20out%20and%20taken%20away%20with%20colorful%20illustrations%20on%20simple%20white%20background&width=400&height=520&seq=k-sub-1&orientation=portrait',
  },
  {
    id: 'k-subtraction-10-2',
    title: 'Subtraction Facts 0-5',
    description:
      'Practice basic subtraction facts with differences up to 5.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20simple%20subtraction%20facts%20worksheet%20with%20numbers%20zero%20to%20five%20and%20friendly%20illustrations%20for%20beginning%20students%20on%20white%20background&width=400&height=520&seq=k-sub-2&orientation=portrait',
  },
  {
    id: 'k-subtraction-10-3',
    title: 'Subtraction Facts 0-10',
    description:
      'Master all subtraction combinations within 10.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20subtraction%20practice%20worksheet%20with%20numbers%20up%20to%20ten%20featuring%20colorful%20problems%20and%20engaging%20design%20on%20clean%20white%20background&width=400&height=520&seq=k-sub-3&orientation=portrait',
  },

  // ---------- Kindergarten – Compose Numbers 11‑19 ----------
  {
    id: 'k-compose-11-19-1',
    title: 'Teen Numbers: Tens and Ones',
    description:
      'Break apart numbers 11-19 into one ten and some ones.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Place Value',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20teen%20numbers%20worksheet%20showing%20tens%20and%20ones%20with%20base%20ten%20blocks%20and%20colorful%20illustrations%20on%20white%20background&width=400&height=520&seq=k-compose-1&orientation=portrait',
  },
  {
    id: 'k-compose-11-19-2',
    title: 'Building Teen Numbers',
    description:
      'Compose numbers 11-19 by combining ten and ones.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Place Value',
    difficulty: 'Intermediate',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20building%20teen%20numbers%20worksheet%20with%20ten%20frames%20and%20ones%20for%20composing%20numbers%20eleven%20to%20nineteen%20on%20white%20background&width=400&height=520&seq=k-compose-2&orientation=portrait',
  },
  {
    id: 'k-compose-11-19-3',
    title: 'Teen Numbers Mixed Practice',
    description:
      'Comprehensive practice composing and decomposing numbers 11-19.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Place Value',
    difficulty: 'Advanced',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20teen%20numbers%20mixed%20practice%20worksheet%20with%20various%20activities%20for%20numbers%20eleven%20to%20nineteen%20on%20clean%20white%20background&width=400&height=520&seq=k-compose-3&orientation=portrait',
  },

  // ---------- Kindergarten – Measurable Attributes ----------
  {
    id: 'k-measurement-1',
    title: 'Longer and Shorter Comparison',
    description:
      'Compare objects by length using longer, shorter, and same.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Measurement',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20length%20comparison%20worksheet%20with%20objects%20of%20different%20lengths%20for%20children%20to%20compare%20using%20longer%20shorter%20concepts%20on%20white%20background&width=400&height=520&seq=k-measure-1&orientation=portrait',
  },
  {
    id: 'k-measurement-2',
    title: 'Heavier and Lighter Comparison',
    description:
      'Compare objects by weight using heavier, lighter, and same.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Measurement',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20weight%20comparison%20worksheet%20with%20balance%20scales%20and%20objects%20for%20comparing%20heavy%20and%20light%20items%20on%20simple%20white%20background&width=400&height=520&seq=k-measure-2&orientation=portrait',
  },
  {
    id: 'k-measurement-3',
    title: 'Taller and Shorter Comparison',
    description:
      'Compare objects by height using taller, shorter, and same.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Measurement',
    difficulty: 'Beginner',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20height%20comparison%20worksheet%20with%20tall%20and%20short%20objects%20like%20trees%20and%20buildings%20for%20children%20to%20compare%20on%20white%20background&width=400&height=520&seq=k-measure-3&orientation=portrait',
  },

  // ---------- Kindergarten – Classify and Sort ----------
  {
    id: 'k-classify-sort-1',
    title: 'Sorting by Color and Shape',
    description:
      'Sort objects into groups by color, shape, and size.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Data',
    difficulty: 'Beginner',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20sorting%20worksheet%20with%20colorful%20shapes%20and%20objects%20organized%20by%20categories%20for%20classification%20practice%20on%20white%20background&width=400&height=520&seq=k-sort-1&orientation=portrait',
  },
  {
    id: 'k-classify-sort-2',
    title: 'Count by Category',
    description:
      'Sort objects and count how many are in each group.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Data',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20counting%20by%20category%20worksheet%20with%20sorted%20groups%20of%20items%20and%20tally%20marks%20on%20simple%20white%20background&width=400&height=520&seq=k-sort-2&orientation=portrait',
  },
  {
    id: 'k-classify-sort-3',
    title: 'Most, Fewest, and Same',
    description:
      'Compare groups to find which has the most, fewest, or same amount.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Data',
    difficulty: 'Advanced',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20comparing%20groups%20worksheet%20with%20most%20fewest%20same%20concepts%20using%20colorful%20objects%20on%20clean%20white%20background&width=400&height=520&seq=k-sort-3&orientation=portrait',
  },

  // ---------- Kindergarten – Identify Shapes ----------
  {
    id: 'k-shapes-2d-1',
    title: '2D Shapes: Circles, Squares, Triangles',
    description:
      'Identify and name basic 2D shapes and count their sides and corners.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Shapes',
    difficulty: 'Beginner',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20two%20dimensional%20shapes%20worksheet%20with%20colorful%20circles%20squares%20triangles%20rectangles%20for%20shape%20identification%20on%20white%20background&width=400&height=520&seq=k-shapes-1&orientation=portrait',
  },
  {
    id: 'k-shapes-2d-2',
    title: 'Shape Attributes Practice',
    description:
      'Count sides and corners of 2D shapes including hexagons.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Shapes',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20shape%20attributes%20worksheet%20with%20shapes%20and%20boxes%20to%20count%20sides%20and%20corners%20with%20bright%20colors%20on%20white%20background&width=400&height=520&seq=k-shapes-2&orientation=portrait',
  },
  {
    id: 'k-shapes-3d-1',
    title: '3D Shapes: Spheres, Cubes, Cylinders',
    description:
      'Identify and name 3D solid shapes in everyday objects.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Shapes',
    difficulty: 'Intermediate',
    pages: 4,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20three%20dimensional%20shapes%20worksheet%20with%20spheres%20cubes%20cylinders%20cones%20and%20real%20world%20objects%20on%20white%20background&width=400&height=520&seq=k-shapes-3d-1&orientation=portrait',
  },
  {
    id: 'k-shapes-mixed-1',
    title: 'Shapes in the Real World',
    description:
      'Find and identify shapes in everyday objects and pictures.',
    grade: 'Kindergarten',
    subject: 'Math',
    topic: 'Shapes',
    difficulty: 'Advanced',
    pages: 3,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=kindergarten%20real%20world%20shapes%20worksheet%20with%20everyday%20objects%20like%20doors%20windows%20balls%20for%20shape%20recognition%20on%20white%20background&width=400&height=520&seq=k-shapes-real&orientation=portrait',
  },

  // ---------- Grade 1 ----------
  {
    id: 'g1-word-problems-1',
    title: 'Addition Word Problems within 20',
    description: 'Solve real-world addition problems with sums up to 20.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20addition%20word%20problems%20worksheet%20with%20illustrated%20story%20scenarios%20and%20numbers%20up%20to%20twenty%20on%20clean%20white%20background&width=400&height=520&seq=g1-word-1&orientation=portrait',
  },
  {
    id: 'g1-word-problems-2',
    title: 'Subtraction Word Problems within 20',
    description:
      'Solve real-world subtraction problems with numbers up to 20.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20subtraction%20word%20problems%20worksheet%20with%20story%20scenarios%20and%20taking%20away%20concepts%20illustrated%20on%20white%20background&width=400&height=520&seq=g1-word-2&orientation=portrait',
  },
  {
    id: 'g1-word-problems-3',
    title: 'Mixed Addition and Subtraction Stories',
    description:
      'Determine whether to add or subtract in various word problem scenarios.',
    grade: 'Grade 1',
    subject: 'Math',
    topic: 'Operations',
    difficulty: 'Advanced',
    pages: 6,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=first%20grade%20mixed%20operations%20word%20problems%20worksheet%20with%20addition%20and%20subtraction%20stories%20for%20problem%20solving%20on%20white%20background&width=400&height=520&seq=g1-word-3&orientation=portrait',
  },

  // ---------- Grade 2 ----------
  {
    id: 'g2-fluency-20-1',
    title: 'Addition Fluency Drills within 20',
    description:
      'Timed practice for automatic recall of addition facts.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Addition',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20addition%20fluency%20worksheet%20with%20rows%20of%20addition%20facts%20within%20twenty%20for%20speed%20practice%20on%20white%20background&width=400&height=520&seq=g2-flu-1&orientation=portrait',
  },
  {
    id: 'g2-fluency-20-2',
    title: 'Subtraction Fluency Drills within 20',
    description:
      'Timed practice for automatic recall of subtraction facts.',
    grade: 'Grade 2',
    subject: 'Math',
    topic: 'Subtraction',
    difficulty: 'Intermediate',
    pages: 5,
    isFree: false,
    downloadUrl: '#',
    thumbnailUrl:
      'https://readdy.ai/api/search-image?query=second%20grade%20subtraction%20fluency%20worksheet%20with%20rows%20of%20subtraction%20facts%20within%20twenty%20for%20speed%20practice%20on%20white%20background&width=400&height=520&seq=g2-flu-2&orientation=portrait',
  },

  // ... (All remaining paid worksheet objects from the original file should be
  // inserted here, each separated by commas and wrapped inside this array.)
];

/* -------------------------------------------------------------------------- */
/*  NOTES
 *
 *  1. The original file defined many worksheet objects after the free‑worksheet
 *     array without placing them inside any container, which caused a syntax
 *     error (`Expected ";" but found ":"`).  All paid worksheets are now
 *     collected in the `worksheetsK5Paid` array.
 *
 *  2. Exporting the paid worksheets as a separate constant makes the module
 *     usable both for free and paid content without breaking existing imports.
 *
 *  3. No runtime logic was changed; only the structure of the data was fixed,
 *     ensuring type‑safety and eliminating the syntax error.
 *
 *  4. If you wish to expose a combined list you can concatenate the two arrays
 *     elsewhere:
 *
 *        export const allWorksheets = [...worksheetsK5, ...worksheetsK5Paid];
 *
 * -------------------------------------------------------------------------- */
